<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="检查记录">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{boliDetail.wujian_id}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{boliDetail.wujian_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">订单号</div>
                <div>{{boliDetail.purchase_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">供应商</div>
                <div>{{boliDetail.supplier_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">到货数</div>
                <div>{{boliDetail.in_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">玻璃种类</div>
                <div>{{boliDetail.boli_type_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">规格型号</div>
              <div>{{boliDetail.boli_type}}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">玻璃番号</div>
                <div>{{boliDetail.boli_no}}</div>
              </div>

              <div class="detailDiv">
                <div class="width1 fontBold">入库日期</div>
                <div>{{boliDetail.in_date}}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">玻璃编号：</div>
                <div>{{boliCheckDetail.glasspiece_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">供应商批号：</div>
                <div>{{boliCheckDetail.supplier_batch_no}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">玻璃厚度实测值：</div>
                <div>{{boliCheckDetail.glass_thickness}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">玻璃厚度标准值：</div>
                <div>{{boliCheckDetail.glass_thickness_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">中空厚度实测值：</div>
                <div>{{boliCheckDetail.middle_thickness}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">中空厚度标准值：</div>
                <div>{{boliCheckDetail.middle_thickness_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">玻璃宽度实测值：</div>
                <div>{{boliCheckDetail.glass_width}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">玻璃宽度标准值：</div>
                <div>{{boliCheckDetail.glass_width_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">玻璃高度实测值：</div>
                <div>{{boliCheckDetail.glass_height}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">玻璃高度标准值：</div>
                <div>{{boliCheckDetail.glass_height_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">弯钢对角线一实测值：</div>
                <div>{{boliCheckDetail.diagonal1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">弯钢对角线一标准值：</div>
                <div>{{boliCheckDetail.diagonal1_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">弯钢对角线二实测值：</div>
                <div>{{boliCheckDetail.diagonal2}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">弯钢对角线二标准值：</div>
                <div>{{boliCheckDetail.diagonal2_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">对角线差：</div>
                <div>{{boliCheckDetail.diagonal_diff}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">使用情况：</div>
                <div>{{boliCheckDetail.use_property}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">对角线差备注：</div>
              <div>{{boliDetail.diagonal_remark}}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">检查员：</div>
                <div>{{boliCheckDetail.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">检查时间：</div>
                <div>{{boliCheckDetail.create_time}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">宽度1实测值：</div>
                <div>{{boliCheckDetail.width1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">宽度1标准值：</div>
                <div>{{boliCheckDetail.width1_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">高度1实测值：</div>
                <div>{{boliCheckDetail.height1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">高度1标准值：</div>
                <div>{{boliCheckDetail.height1_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">宽度2实测值：</div>
                <div>{{boliCheckDetail.width2}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">宽度2标准值：</div>
                <div>{{boliCheckDetail.width2_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">高度2实测值：</div>
                <div>{{boliCheckDetail.height2}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">高度2标准值：</div>
                <div>{{boliCheckDetail.height2_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">弯钢间隙实测值：</div>
                <div>{{boliCheckDetail.extend_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">弯钢间隙标准值：</div>
                <div>{{boliCheckDetail.extend_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">异形对角线一实测值：</div>
                <div>{{boliCheckDetail.irregular_diagonal1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">异形对角线一标准值：</div>
                <div>{{boliCheckDetail.irregular1_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">异形对角线二实测值：</div>
                <div>{{boliCheckDetail.irregular_diagonal2}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">异形对角线二标准值：</div>
                <div>{{boliCheckDetail.irregular2_standard}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(表)应力值一：</div>
                <div>{{boliCheckDetail.yingli_value1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">(表)应力值二：</div>
                <div>{{boliCheckDetail.yingli_value2}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(表)应力值三：</div>
                <div>{{boliCheckDetail.yingli_value3}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">(表)应力值四：</div>
                <div>{{boliCheckDetail.yingli_value4}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(表)应力值五：</div>
                <div>{{boliCheckDetail.yingli_value5}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(里)应力值六：</div>
                <div>{{boliCheckDetail.yingli_value6}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">(里)应力值七：</div>
                <div>{{boliCheckDetail.yingli_value7}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(里)应力值八：</div>
                <div>{{boliCheckDetail.yingli_value8}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">(里)应力值九：</div>
                <div>{{boliCheckDetail.yingli_value9}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">(里)应力值十：</div>
                <div>{{boliCheckDetail.yingli_value10}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">氩气实测值：</div>
                <div>{{boliCheckDetail.ar_value}}</div>
              </div>
            </div>
            <el-image v-show="boliCheckDetail.ar_pictures_ids.length !== 0" v-for="imageUrl in boliCheckDetail.ar_pictures_list" :preview-src-list="boliCheckDetail.ar_pictures_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            <div v-for="boliCheckItem in boliCheckItemRecord" v-bind:key="boliCheckItem.id">
              <div class="detailDiv"><text class="fontBold">{{boliCheckItem.itemTitle}}：</text><text>{{boliCheckItem.resultText}}</text></div>
              <div v-show="boliCheckItem.result_pics_ids.length !== 0">
                <el-image v-for="imageUrl in boliCheckItem.result_pics_list" :preview-src-list="boliCheckItem.result_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
              </div>
            </div>
            <el-image v-show="boliCheckDetail.pictures_pics_ids.length !== 0" v-for="imageUrl in boliCheckDetail.pictures_pics_list" :preview-src-list="boliCheckDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{boliCheckDetail.remark}}</div>
            </div>
            <div class="nowrapDiv">
              <div class="width5 fontBold" style="display: flex;justify-content: center;">
                <div>表</div>
              </div>
              <div class="width5 fontBold" style="display: flex;justify-content: center;">
                <div>里</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(0)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[0] }}</div>
                <div v-if="!getNg(1)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[1] }}</div>
                <div v-if="!getNg(2)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[2] }}</div>
                <div v-if="!getNg(3)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[3] }}</div>
              </div>
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(16)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[16] }}</div>
                <div v-if="!getNg(17)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[17] }}</div>
                <div v-if="!getNg(18)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[18] }}</div>
                <div v-if="!getNg(19)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[19] }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(4)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[4] }}</div>
                <div v-if="!getNg(5)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[5] }}</div>
                <div v-if="!getNg(6)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[6] }}</div>
                <div v-if="!getNg(7)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[7] }}</div>
              </div>
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(20)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[20] }}</div>
                <div v-if="!getNg(21)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[21] }}</div>
                <div v-if="!getNg(22)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[22] }}</div>
                <div v-if="!getNg(23)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[23] }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(8)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[8] }}</div>
                <div v-if="!getNg(9)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[9] }}</div>
                <div v-if="!getNg(10)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[10] }}</div>
                <div v-if="!getNg(11)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[11] }}</div>
              </div>
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(24)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[24] }}</div>
                <div v-if="!getNg(25)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[25] }}</div>
                <div v-if="!getNg(26)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[26] }}</div>
                <div v-if="!getNg(27)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[27] }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(12)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[12] }}</div>
                <div v-if="!getNg(13)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[13] }}</div>
                <div v-if="!getNg(14)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[14] }}</div>
                <div v-if="!getNg(15)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[15] }}</div>
              </div>
              <div class="width5" style="display: flex;justify-content: center;">
                <div v-if="!getNg(28)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[28] }}</div>
                <div v-if="!getNg(29)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[29] }}</div>
                <div v-if="!getNg(30)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[30] }}</div>
                <div v-if="!getNg(31)" class="ngdiv"></div>
                <div v-else class="ngdiv1">{{ ngStringList[31] }}</div>
              </div>
            </div>
            <div v-show="boliCheckDetail.broken_later">
              <div class="nowrapDiv">
                <div class="fontBold">后损伤原因：</div>
                <div>{{boliCheckDetail.broken_reason}}</div>
              </div>
              <div class="nowrapDiv">
                <div class="fontBold">后损伤备注：</div>
                <div>{{boliCheckDetail.broken_remark}}</div>
              </div>
              <div class="nowrapDiv">
                <div class="fontBold">后损伤图片：</div>
              </div>
              <el-image v-show="boliCheckDetail.broken_pics_ids.length !== 0"  v-for="imageUrl in boliCheckDetail.broken_pics_list" :preview-src-list="boliCheckDetail.broken_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="不良记录">
        <div v-for="item in checkNgList" :key="item.id" >
          <div class="nowrapDiv">
            <div class="detailDiv">
              <div class="width1 fontBold">不良原因</div>
              <div>{{item.ng_reason}}</div>
            </div>
          </div>
          <div class="nowrapDiv">
            <div class="detailDiv">
              <div class="width1 fontBold">处理人</div>
              <div>{{item.user}}</div>
            </div>
            <div class="detailDiv">
              <div class="width1 fontBold">处理时间</div>
              <div>{{item.update_time}}</div>
            </div>
          </div>
          <div class="nowrapDiv">
            <div class="detailDiv">
              <div class="width1 fontBold">处理方式</div>
              <div>{{item.type}}</div>
            </div>
            <div class="detailDiv">
              <div class="width1 fontBold">处理结果</div>
              <div>{{item.result}}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "BusBoliCheckInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      ngList: [],
      ngStringList: {},
      boliDetail:{},
      boliCheckDetail:{},
      boliCheckItemRecord:[],
      checkNgList:[]
    }
  },
  methods:{
    getNg(position){
      return this.ngList.includes(position)
    },
    async getBoliDetail(){
      let {data: res} = await this.$axios.get('/api/boli/detail?id=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.boliDetail = res.data
      }
    },
    async getBoliCheckDetail(){
      let {data: res} = await this.$axios.get('/api/boli/check/detail?id=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.boliCheckDetail = res.data
      }
    },
    async getBoliCheckItemRecord(){
      let {data: res} = await this.$axios.get('/api/boli/check/item/record?checkId=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.boliCheckItemRecord = res.data
        for (var i = 0; i < this.boliCheckItemRecord.length;i++){
          if (this.boliCheckItemRecord[i]['bad_position'] !== ""){
            var badPosition = this.boliCheckItemRecord[i]['bad_position'].split(",")
            for (var x=0;x<badPosition.length;x++){
              this.ngList.push(parseInt(badPosition[x]))
              this.ngStringList[badPosition[x]] = this.boliCheckItemRecord[i]['identity']
            }
          }
        }
      }
    },
    async getCheckNgList(){
      let {data: res} = await this.$axios.post('/bus/datasource/getBoLiCheckNg', this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.checkNgList = res.data
      }
    },
  },
  created() {
    this.getBoliDetail()
    this.getBoliCheckDetail()
    this.getBoliCheckItemRecord()
    this.getCheckNgList()
  }
}
</script>

<style scoped>
.checkInfo{
  background-color: #F4F8FD;
}
.detail{
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}
.detailDiv{
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fontBold{
  font-weight: bold;
}
.width1{
  width: 25%;
}
.width2{
  width: 39%;
}
.width3{
  width: 12.5%;
}
.width4{
  width: 30%;
}
.width5{
  width: 50%;
}
.nowrapDiv{
  display: flex;
  flex-wrap: nowrap;
}
.ngdiv{
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ngdiv1{
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}
.imageStyle{
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>
